/**
 * Hook: MenuBar real data — agent stats + FLZ balance
 * Polls every 30s
 */
import { useEffect, useState } from 'react'
import { API_URL, apiFetch } from '../../../config/api'

export interface AgentStats {
  total_agents: number
  active_agents: number
  platform_agents: number
  user_agents: number
}

export interface MenuBarData {
  agentStats: AgentStats | null
  flzBalance: number
  loading: boolean
}

export function useMenuBarData(): MenuBarData {
  const [agentStats, setAgentStats] = useState<AgentStats | null>(null)
  const [flzBalance, setFlzBalance] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) { setLoading(false); return }

    const fetch = async () => {
      try {
        const [agentRes, walletRes] = await Promise.allSettled([
          apiFetch(`${API_URL}/api/platform/stats`).then(r => r.json()),
          apiFetch(`${API_URL}/api/wallet/balance`).then(r => r.json()),
        ])
        if (agentRes.status === 'fulfilled') {
          setAgentStats(agentRes.value as AgentStats)
        }
        if (walletRes.status === 'fulfilled') {
          const d = walletRes.value as { wallet_balance?: number } | undefined | null
          setFlzBalance(d?.wallet_balance || 0)
        }
      } catch { /* silent */ }
      finally { setLoading(false) }
    }

    void fetch()
    const interval = setInterval(() => { void fetch() }, 30000)
    return () => clearInterval(interval)
  }, [])

  return { agentStats, flzBalance, loading }
}
